import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getWeightedRandomVariant = (): number => {
  const weights = [
    { value: 0, weight: 10 },
    { value: 1, weight: 5 },
    { value: 2, weight: 2 },
    { value: 3, weight: 0.2 }, // Rarest
  ];

  const weightedArray: number[] = [];
  weights.forEach(item => {
    for (let i = 0; i < item.weight; i++) {
      weightedArray.push(item.value);
    }
  });

  const randomIndex = Math.floor(Math.random() * weightedArray.length);
  return weightedArray[randomIndex];
}


/**
 * Server action to generate a new MongoDB ObjectId string.
 * @returns A promise that resolves with a new ObjectId string.
 */
export function generateObjectIdString(input?: string): string {
  // The input parameter is not used by crypto.randomUUID()
  return input ?? crypto.randomUUID();
}